import { render, staticRenderFns } from "./RealPositionControl.vue?vue&type=template&id=4ad159b4&scoped=true"
import script from "./RealPositionControl.vue?vue&type=script&lang=js"
export * from "./RealPositionControl.vue?vue&type=script&lang=js"
import style0 from "./RealPositionControl.vue?vue&type=style&index=0&id=4ad159b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad159b4",
  null
  
)

export default component.exports